(ns practitest.frontend.milestone.subs
  (:require
   [re-frame.core :as re-frame]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.subs :as subs]))

(re-frame/reg-sub
 ::show-link-entities-modal?
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key]]
   (get-in entity [state-key :show-link-entities-modal?])))

(re-frame/reg-sub
 ::link-entities-show-views?
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key]]
   (get-in entity [state-key :show-views?] true)))

(re-frame/reg-sub
 ::link-entities-filters
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key default-filter-name]]
   (cons
    {:id "_DEFAULT_"
     :name default-filter-name}
    (get-in entity [state-key :filters]))))

(re-frame/reg-sub
 ::link-entities-current-filter-selected
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key]]
   (get-in entity [state-key :current-filter-selected])))

(re-frame/reg-sub
 ::entities-current-page
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key]]
   (get-in entity [state-key :current-page])))

(re-frame/reg-sub
 ::entities-total-count
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key]]
   (get-in entity [state-key :total-count] 0)))

(re-frame/reg-sub
 ::entities-full-data?
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key]]
   (get-in entity [state-key :full-data?])))

(re-frame/reg-sub
 ::selected-entities
 :<- [::subs/entity :milestone]
 (fn [entity [_ state-key]]
   (let [cache-entities (get-in entity [state-key :cache-entities])
         selection (get-in entity [state-key :selection] #{})]
     (mapv cache-entities selection))))

(re-frame/reg-sub
  ::milestone-filter-statuses
  (fn [_]
    [(re-frame/subscribe [::subs/current-project])
     (re-frame/subscribe [::subs/entity :milestone])])
  (fn [[project milestone] _]
    (if-let [saved-filtering (grid-storage/load-milestone-index-filtering (:id project))]
      (into #{} saved-filtering)
      (get milestone :show-by-status #{"Active"}))))
